/**
 * DEPRECATED CustomFields Mixins
 * Only used by CF legacy (resources/assets/js/vue/components/inputs/custom/)
 */

export default {
    props: {
        mode: {
            type: String
        },
        prop: {
            type: [Array, Object],
            required: false,
            default: false
        },
        value: {
            type: [Array, Object, Boolean],
            required: false,
            default: false
        },
        notStoredValue: Boolean,
        // create / edit
        context: {
            type: String,
            required: false,
            default: 'create'
        }
    },
    data() {
        return {
            templateData: {
                boolValue: null,
                customFieldId: this.prop.id,
                decimalValue: null,
                id: null,
                numericValue: null, // to update
                stringValue: null,
                textValue: null,
                timestampValue: null,
                type: this.prop.type,
            }
        }
    },
    mounted() {
        if (this.mode !== 'edit' && this.notStoredValue) {
            this.$el.innerHTML = `<p class="w-1 gray-40">${this.$l10n.__('N/C')}</p>`;
        }
    },
    computed: {
        reference(){
            return `cf_${this.prop.type}_${this.prop.id}`
        }
    },
    methods: {
        checkMinMaxParams(value) {
            if (this.prop.max != '' && value.length > parseInt(this.prop.max)) {
                this.$emit('error', { name: this.reference, message: this.$l10n.__('Limite atteinte') })
                return false
            }
            if (this.prop.min != '' && value.length < parseInt(this.prop.min)) {
                this.$emit('error', { name: this.reference, message: this.$l10n.__('Limite atteinte') })
                return false
            }
            return true
        },
        
    }
}